import React, { useState } from 'react';
import axios from '../../axiosInstance';
import { Button } from '../ui/button';
import { useTranslation } from 'react-i18next';

// Hilfsfunktion für JSON-Parsing mit Fallback
function safeParse(value) {
  if (Array.isArray(value)) return value;
  if (typeof value !== 'string') return [];
  try {
    const parsed = JSON.parse(value);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function MentoringAgreementView({
  menteeName,
  mentorName,
  agreement,
  onConfirm
}) {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [confirmed, setConfirmed] = useState(agreement?.mentor_confirmed || false);
  const { t } = useTranslation();

  const handleConfirm = async () => {
    setIsSubmitting(true);
    try {
      await axios.patch(
        '/mentoring/agreement/confirm',
        { agreementId: agreement.agreement_id },
        { withCredentials: true }
      );
      setConfirmed(true);
      if (onConfirm) onConfirm();
    } catch (err) {
      console.error('Bestätigung fehlgeschlagen:', err);
      alert(t('mentoringAgreementView.confirmError'));
    } finally {
      setIsSubmitting(false);
    }
  };

  const {
    period,
    turnus,
    contact_option,
    location,
    goals = [],
    topics = [],
    why_mentoring = '',
    mentee_confirmed,
    mentee_name,
    mentor_name
  } = agreement;

  // Namen aus Agreement bevorzugen, sonst Fallback auf Props
  const mentee = mentee_name && mentee_name.trim() !== '' ? mentee_name : (menteeName || "---");
  const mentor = mentor_name && mentor_name.trim() !== '' ? mentor_name : (mentorName || "---");

  const parsedGoals = Array.isArray(goals) ? goals : safeParse(goals);
  const parsedTopics = Array.isArray(topics) ? topics : safeParse(topics);

  return (
    <div className="bg-white text-black p-6 rounded-xl shadow max-w-3xl mx-auto space-y-6">
      <h2 className="text-xl font-bold">{t('mentoringAgreementView.heading')}</h2>

      <section>
        <p className="mb-2">
          {t('mentoringAgreementView.parties', {
            mentor,
            mentee
          })}
        </p>
        <p className="text-sm text-gray-600"><strong>{t('mentoringAgreementView.period')}</strong> {period}</p>
        <p className="text-sm text-gray-600"><strong>{t('mentoringAgreementView.turnus')}</strong> {turnus}</p>
        <p className="text-sm text-gray-600"><strong>{t('mentoringAgreementView.contact')}</strong> {contact_option}</p>
        <p className="text-sm text-gray-600"><strong>{t('mentoringAgreementView.location')}</strong> {location}</p>
      </section>

      <section>
        <p className="mt-6 mb-2">{t('mentoringAgreementView.goalsTitle')}</p>
        <ul className="list-disc list-inside">
          {parsedGoals.map((goal, index) => <li key={index}>{goal}</li>)}
        </ul>
      </section>

      <section>
        <p className="mb-2">{t('mentoringAgreementView.topicsTitle')}</p>
        <ul className="list-disc list-inside">
          {parsedTopics.map((topic, index) => <li key={index}>{topic}</li>)}
        </ul>
      </section>

      <section>
        <p className="mb-2">{t('mentoringAgreementView.motivationTitle')}</p>
        <p className="text-gray-800">{why_mentoring}</p>
      </section>

      <section className="space-y-4">
        <p>{t('mentoringAgreementView.intro')}</p>
        <p>{t('mentoringAgreementView.principlesIntro')}</p>
        <ul className="list-disc list-inside">
          {(t('mentoringAgreementView.principles', { returnObjects: true }) || []).map((p, i) => (
            <li key={i}>{p}</li>
          ))}
        </ul>
      </section>

      {!confirmed && agreement && (
        <div className="mt-6 text-center">
          <Button
            onClick={handleConfirm}
            disabled={isSubmitting}
            className="bg-mentixxgreen text-black"
          >
            {t('mentoringAgreementView.confirmButton')}
          </Button>
        </div>
      )}
    </div>
  );
}

export default MentoringAgreementView;
